import styled from 'styled-components'

export const Container = styled.div`
  z-index: 9;
`

export const EditWindow = styled.div`
  display: flex;
  justify-content: flex-start;
`

export const TileDetailsContainer = styled.div`
  border: 1px solid #336699;
  padding: 0.5rem;
`

export const Board = styled.div`
  position: relative;
  margin: 1.5rem 0 0;
`

export const Row = styled.div`
  ${({ theme: { colors }, width, height }) => `
    border: 1px solid ${colors('chrome')};
    width: ${width}px;
    height: ${height}px;
    background-image: linear-gradient(90deg,
    ${colors('background')} 47.50%,
    ${colors('chrome')} 47.50%,
    ${colors('chrome')} 50%,
    ${colors('background')} 50%,
    ${colors('background')} 97.50%,
    ${colors('chrome')} 97.50%,
    ${colors('chrome')} 100%);
    background-size: 40.00px 40.00px;
    `}
`

export const Color = styled.div`
  ${({ color }) => `
    position: relative;
  width: 2rem;
  height: 2rem;
  background: ${color};
  &.solid:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 2rem;
    height: 2rem;
    background: repeating-linear-gradient(
      45deg,
      transparent,
      transparent 3px,
      rgba(255,255,255,0.125) 3px,
      rgba(255,255,255,0.125) 6px
    );
  }
`}
`
